import { Card, Image } from "antd";
import "../../styles/ProductCard.scss";
import { ItemModel } from "../../../../../../infrastructure/model/ProductItemModel";

interface ProductCardProps {
  item: ItemModel;
  onAdd?: (item: ItemModel) => void;
  variant?: "flash" | "best" | "normal";
}

function ProductCard(props: ProductCardProps) {
  const { item, onAdd, variant = "normal" } = props;
  return (
    <div className="product-card">
      <Card
        hoverable
        cover={
          <div className="image-wrapper">
            {item.image ? (
              <Image preview={false} src={item.image} alt={item.name} className="product-image" />
            ) : (
              <div className="image-placeholder">☕</div>
            )}
          </div>
        }
      >
        <div className="product-content">
          <h3 className="product-name">{item.name}</h3>

          <div className="product-price">{item?.size_mapping?.[0]?.price?.toLocaleString()} đ</div>

          {onAdd && (
            <button className="add-btn" onClick={() => onAdd(item)}>
              + Thêm
            </button>
          )}
        </div>
      </Card>
    </div>
  );
}

export default ProductCard;
